export function createAdvisorCredentials() {
  const bytes = new Uint8Array(32);
  globalThis.crypto.getRandomValues(bytes);
  return {
    sessionId: globalThis.crypto.randomUUID(),
    token: Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(''),
  };
}
